import React, { useState } from 'react';
import CRMModal from '../crm/CRMModal';
import ProjectVendorPicker from './ProjectVendorPicker';

export default function ProjectVendorSelectModal({ projectId, workspace, projectName, onClose, onSave, busy, error }) {
    const [selection, setSelection] = useState([]);
    const submit = event => {
        event.preventDefault();
        if (!selection.length || busy) return;
        onSave({ type: 'addVendors', vendors: selection });
    };
    return <CRMModal title="Add vendors from CRM" subtitle={`${projectName} · ${workspace === 'test' ? 'Test workspace' : 'Live workspace'}`} eyebrow="PROJECT VENDORS" wide onClose={onClose}>
        <form className="crm-form po-vendor-modal" onSubmit={submit}>
            <div className="crm-form-scroll">
                {error && <p className="crm-error" role="alert">{error}</p>}
                <ProjectVendorPicker projectId={projectId} workspace={workspace} onSelection={setSelection} busy={busy} />
            </div>
            <footer className="crm-modal-foot"><span>{workspace === 'test' ? 'Test workspace' : 'Live workspace'}</span><div><button type="button" className="crm-button" disabled={busy} onClick={onClose}>Cancel</button><button type="submit" className="crm-button crm-button-primary" disabled={busy || !selection.length}>{busy ? 'Adding…' : `Add selected${selection.length ? ` (${selection.length})` : ''}`}</button></div></footer>
        </form>
    </CRMModal>;
}
